export default "__VITE_ASSET__DFhmYg1W__"